export type VehicleAlbum = {
  translation: string;
  id: string;
  name: string;
};
